import React, { Component } from "react";

import { Col } from "react-flexbox-grid";
import Paper from "material-ui/Paper";
import Divider from "material-ui/Divider";
import { Tabs, Tab } from "material-ui/Tabs";
import Typography from "material-ui-next/Typography";

import GeneralInfo from "./general-info";
import GeographicInfo from "./geographic-info";
import CustomInfo from "./custom-info";

import {
  Page,
  StyledButton,
  IconButton,
  Loadable,
  Errorable
} from "components/support";
import { colors } from "assets";

class CustomerForm extends Component {
  tabs = [
    { label: "Geral", component: GeneralInfo },
    { label: "Endereço", component: GeographicInfo },
    { label: "Informações Personalizadas", component: CustomInfo }
  ];

  tabsItem = tab => {
    const { presenter, viewModel } = this.props;
    const { customer, formErrors, customFieldsFormErrors, fields } = viewModel;

    if (customer) {
      return (
        <Tab label={tab.label} key={tab.label} className="tab-content">
          <tab.component
            fields={fields}
            customer={customer}
            errors={formErrors}
            customFieldsErrors={customFieldsFormErrors}
            onChange={(field, subfield, value) =>
              presenter.onChange(field, subfield, value)
            }
          />
        </Tab>
      );
    }
  };

  render() {
    const { presenter, viewModel } = this.props;
    const { title, error, loading } = viewModel;

    return (
      <Page>
        <Col xs={12}>
          <Typography type="display1" className="pb-sm">
            <IconButton
              icon="arrow_back"
              onClick={() => presenter.onGoBack()}
            />
            {title}
          </Typography>
          <Errorable error={!!error} errorMessage={error}>
            <Loadable loading={loading}>
              <Paper elevation={1}>
                <Tabs
                  inkBarStyle={{ backgroundColor: colors.accent.normal }}
                  tabItemContainerStyle={{
                    backgroundColor: colors.primary.dark
                  }}
                  className="customer-form-tabs"
                >
                  {this.tabs.map(this.tabsItem)}
                </Tabs>

                <Divider className="mt-sm" />

                <div className="text-right p-sm">
                  <StyledButton
                    label="Cancelar"
                    onClick={() => presenter.onGoBack()}
                    flat
                  />

                  <StyledButton
                    label="Salvar Cliente"
                    primary={true}
                    className="customer__submit"
                    onTouchTap={() => presenter.onSendForm()}
                  >
                    Salvar Cliente
                  </StyledButton>
                </div>
              </Paper>
            </Loadable>
          </Errorable>
        </Col>
      </Page>
    );
  }
}

export default CustomerForm;



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/form/view.jsx